import { Injectable } from '@angular/core';
import { MiaHttpService, ApiResponse } from '@mobileia/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { MIAAccessToken, MIAUser, AuthenticationService, MiaAuthHttpService } from '@mobileia/authentication';
import { map } from 'rxjs/operators';
import { StorageMap } from '@ngx-pwa/local-storage';

@Injectable({
  providedIn: 'root'
})
export class UserService extends MiaAuthHttpService {

  protected _baseUrl = '';
  
  constructor(
    protected http: HttpClient,
    protected authService: AuthenticationService
  ) {
    super(http, authService);
  }

  fetchProfile(): Observable<ApiResponse<any>> {
    return this.postAuthObject(environment.baseUrl + 'mia-auth/me', { });
  }

  validDocument(document: string): Observable<ApiResponse<any>> {
    return this.postObject(environment.baseUrl + 'auth/document', { document: document });
  }

  saveEmail(document: string, email: string): Observable<ApiResponse<boolean>> {
    return this.postObject(environment.baseUrl + 'auth/save-email', { document: document, email: email });
  }

  recoveryPass(document: string): Observable<ApiResponse<boolean>> {
    return this.postObject(environment.baseUrl + 'auth/recovery', { document: document });
  }

  recoveryPassWithEmail(email: string): Observable<ApiResponse<boolean>> {
    return this.postObject(environment.baseUrl + 'auth/recovery-with-email', { email: email });
  }

  loginInternal(document: string, password: string): Observable<ApiResponse<{ access_token: MIAAccessToken, user: MIAUser }>> {
    return this.postObject(environment.baseUrl + 'auth/login', { document: document, password: password })
    .pipe(map(data => {

      // Verificar si se logueo correctamente
      if (data.success) {
        // Guardar AccessToken
        this.authService.saveDataLoginInternal(data.response.access_token.access_token, data.response.access_token.user_id, data.response.user);
        // Guardar que esta logueado
        this.authService.isLoggedIn.next(true);
      }

      return data;
    }));
  }
}